<script setup lang="ts">
import { $getSelection, $isRangeSelection } from "lexical";
import { useLexicalComposer } from "lexical-vue";

const editor = useLexicalComposer();

const insert = (text: string) => {
  editor.update(() => {
    const selection = $getSelection();
    if (!$isRangeSelection(selection)) {
      return;
    }

    selection.insertText(text);
  });
};

defineExpose({
  insert,
});
</script>

<template>
  <slot />
</template>
